'use client';

import { useSearchParams } from 'next/navigation';
import { useI18nPathname } from '../isomorphic';

interface UsePathnameOptions {
  preserveSearchParams?: boolean;
}

export const usePathname = ({ preserveSearchParams = false }: UsePathnameOptions = {}) => {
  const pathname = useI18nPathname();
  const searchParams = useSearchParams();

  return preserveSearchParams ? `${pathname}?${searchParams.toString()}` : pathname;
};
